import React, { useState } from 'react'
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'

import { BaseDialog, Dai } from 'components'

import theme from 'theme'
import { routes } from 'Routes'
import { reverse } from 'named-urls'
import useStyles from './styles'
import palette from 'theme/palette'
import constants from 'constants/index'

const DocumentCreationModeDialog = ({ id }) => {
  const [openDialog, setOpenDialog] = useState(false)

  const classes = useStyles()
  const history = useHistory()

  const { control, handleSubmit } = useForm({
    defaultValues: {
      formType: constants.documents.AUTOMATIC_GENERATION_FORM,
    },
  })

  const { AUTOMATIC_GENERATION_FORM } = constants.documents

  const handleOpenDialog = () => setOpenDialog(true)
  const handleCloseDialog = () => setOpenDialog(false)

  const onSubmit = (data) => {
    if (data.formType === AUTOMATIC_GENERATION_FORM) {
      history.push(reverse(routes.documents.generate))
    } else {
      history.push(routes.documents.new)
    }

    handleCloseDialog()
  }

  return (
    <>
      <Button
        id={id}
        variant="contained"
        color="primary"
        onClick={handleOpenDialog}
      >
        Novo Documento
      </Button>

      <BaseDialog
        title="Novo documento"
        open={openDialog}
        setOpen={setOpenDialog}
        dialogSize="sm"
        fullWidth
        closeButtonText="Cancelar"
        actionButtonText="Criar"
        actionButton={handleSubmit(onSubmit)}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <Controller
                control={control}
                name="formType"
                as={
                  <RadioGroup>
                    <FormControlLabel
                      value={constants.documents.AUTOMATIC_GENERATION_FORM}
                      control={<Radio />}
                      className={classes.optionBox}
                      label={
                        <>
                          <Box
                            display="flex"
                            alignItems="flex-end"
                            gridGap={theme.spacing(0.5)}
                          >
                            <Typography
                              variant="body1"
                              className={classes.optionTitle}
                            >
                              Crie com a DAI
                            </Typography>

                            <Box mb={0.5}>
                              <Dai.StarIcon
                                size="14px"
                                color={palette.dai.shinyBlue}
                              />
                            </Box>
                          </Box>
                          <Typography variant="caption">
                            Criação automática de documentos com modelos
                            inteligentes
                          </Typography>
                        </>
                      }
                    />
                    <FormControlLabel
                      value={constants.documents.BLANK_FORM}
                      control={<Radio />}
                      className={classes.optionBox}
                      label={
                        <>
                          <Typography
                            variant="body1"
                            className={classes.optionTitle}
                          >
                            Documento em Branco
                          </Typography>
                          <Typography variant="caption">
                            Anexe um documento existente ou crie seu documento
                            do zero
                          </Typography>
                        </>
                      }
                    />
                  </RadioGroup>
                }
                mode="onChange"
              />
            </FormControl>
          </Grid>
        </Grid>
      </BaseDialog>
    </>
  )
}

export default DocumentCreationModeDialog
